import {todo, error} from '../types'
// 子模块的数据，作为全局store下state的sub-tree
const state = {
  isLoading: true,
  isLoadingList: true,
  isRequestError: false,
  errorMsg: '',
  isSubmitting: false,
  isDeleting: false,
  configInfo: {},
  newTodo: null,
  todoList: [],
  errorShow: false,
  errorInfo: '',
  oldIds: [],
  isCreate: false
}

// function updateListOrder(list, todos) {
//   let resetTodoList = []
//   _.forEach(todos, (todo) => {
//     let filterTodo = _.filter(list, {'id': todo.id})
//     resetTodoList.push(filterTodo[0])
//   })
//   return resetTodoList
// }

// 对子模块数据的操作
const mutations = {
  // 取得todos的列表
  [todo.GET_ALL](state, {todos}) {
    state.isLoadingList = false
    state.todoList = []
    state.todoList = todos
    state.todoList.forEach(item => {
      state.oldIds.push(item.id)
    })
  },

  [todo.GET_ALL_REQ](state) {
    state.isLoadingList = true
    state.errorMsg = ''
    state.isRequestError = false
  },

  [todo.GET_ALL_FAIL](state, {errorMsg}) {
    state.isLoadingList = false
    state.isRequestError = true
    state.errorMsg = errorMsg
  },

  // 取得配置的信息
  [todo.GET_CONFIGINFO](state, {info}) {
    state.isLoading = false
    state.isRequestError = false
    state.errorMsg = ''
    state.configInfo = info
  },

  [todo.GET_CONFIGINFO_REQ](state) {
    state.isRequestError = false
    state.errorMsg = ''
    state.isLoading = true
  },

  [todo.GET_CONFIGINFO_FAIL](state, {errorMsg}) {
    state.isLoading = false
    state.isRequestError = true
    state.errorMsg = errorMsg
  },

  // 更新配置的信息
  [todo.UPDATE_CONFIGINFO_REQ](state) {
    state.isSubmitting = true
  },

  [todo.UPDATE_CONFIGINFO](state, {info}) {
    state.isSubmitting = false
    state.configInfo = info
  },

  [todo.UPDATE_CONFIGINFO_FAIL](state, {errorMsg}) {
    state.isSubmitting = false
    state.errorMsg = errorMsg
  },

  // 创建todo
  [todo.CREATE_REQ](state, data) {
    state.isSubmitting = true
    state.todoList.push({
      id: -1,
      todo_content: data,
      todo_status: 'uncompleted'
    })
  },

  [todo.CREATE](state, {todo}) {
    state.isSubmitting = false
    state.newTodo = todo
    state.todoList.forEach(item => {
      if (item.id == -1) {
        item.id = todo.id
      }
    })
  },

  [todo.CREATE_FAIL](state, {errorMsg}) {
    state.isSubmitting = false
    state.errorMsg = errorMsg
    state.isRequestError = true
  },

  // 更新todo
  [todo.UPDATE_REQ](state, id, data) {
    state.isSubmitting = true
    _.forEach(state.todoList, (item) => {
      if (id == item.id && data.status) {
        item.todo_status = data.status
      }
    })
  },

  [todo.UPDATE](state, {todo}) {
    state.isSubmitting = false
    _.forEach(state.todoList, (item) => {
      if (item.id == todo.id) {
        item = todo
      }
    })
  },

  [todo.UPDATE_FAIL](state, {errorMsg}) {
    state.isSubmitting = false
    state.errorMsg = errorMsg
  },

  //删除todo
  [todo.DELETE_REQ](state, id) {
    state.todoList.forEach((item, index) => {
      if (item.id == id) {
        state.todoList.splice(index,1)
      }
    })
  },

  [todo.DELETE](state) {
    state.isDeleting = false
  },

  [todo.DELETE_FAIL](state, {errorMsg}) {
    state.isDeleting = false
    state.errorMsg = errorMsg
  },

  // 更新todo的顺序
  [todo.UPDATE_ORDER](state, {todos}) {
    state.isSubmitting = false
    state.todoList = todos
  },

  [todo.UPDATE_ORDER_REQ](state) {
    state.errorMsg = ''
    state.isRequestError = false
    state.isSubmitting = true
  },

  [todo.UPDATE_ORDER_FAIL](state, data) {
    state.isSubmitting = false
    state.isRequestError = true
    state.errorMsg = data.errorMsg
  },

  [error.ERROR_SHOW](state, info) {
    state.errorShow = true
    state.errorInfo = info
  },

  [error.ERROR_HIDE](state) {
    state.errorShow = false
  }
}

export default {
  state,
  mutations
}

// import {todo} from '../types'

// const state = {
//   todoList: [{
//     item_id: 1,
//     content: '3号上午给孩子打疫苗',
//     isFinished: true
//   },{
//     item_id: 2,
//     content: '去验房，并办理装修申请手续',
//     isFinished: true
//   },{
//     item_id: 3,
//     content: '给老婆买iPhone 7 Plus顶配，并且带Apple Care+ 服务',
//     isFinished: true
//   },{
//     item_id: 4,
//     content: '放假前先去体检慈铭体检',
//     isFinished: false
//   },{
//     item_id: 5,
//     content: '去五彩城取大闸蟹、买料酒和朗姆酒',
//     isFinished: false
//   }]
// }

// const mutations = {
//   [todo.GET_ALL](state) {

//   },
//   [todo.CREATE_REQ](state, text) {
//     state.todoList.push({
//       item_id: -1,
//       content: text,
//       isFinished: false
//     })
//   }
// }

// export default {
//   state,
//   mutations
// }


/** WEBPACK FOOTER **
 ** ./src/vuex/modules/todo.js
 **/